import { game } from '../main';
const clips: {[key: string]: Phaser.Sound} = {};

export function playSound(key: string): void {
  if (!clips[key]) {
    if (!game.cache.checkSoundKey(key)) return;
    clips[key] = game.add.audio(key);
  }
  clips[key].play();
}